import React from "react";
import { Link } from "react-router-dom";
import { SEO_PAGES } from "../data/seoPages";
import { SEO_EVENT_LANDINGS } from "../data/seoEventLandings";
import { Anchor } from "lucide-react";

// Categorised "Browse All Cruise Types" link grid that sits above the site footer.
// Pulls live from BOTH SEO_PAGES (legacy template) and SEO_EVENT_LANDINGS (long-form
// EventLanding template) so new pages light up automatically in the right column.

const CATEGORIES = [
 {
  title: "Celebrations",
  slugs: [
   "birthday-cruises-sydney-harbour", "wedding-cruises-sydney-harbour",
   "engagement-party-cruises-sydney", "engagement-proposal-cruises-sydney",
   "anniversary-cruises-sydney", "graduation-cruises-sydney",
   "school-formal-cruises-sydney", "bridal-shower-cruises-sydney",
   "baby-shower-cruises-sydney", "family-celebration-cruises-sydney",
   "celebration-cruises-sydney-harbour", "milestone-birthday-cruises-sydney",
   "vow-renewal-cruises-sydney", "honeymoon-cruises-sydney",
   "retirement-party-cruises-sydney", "family-reunion-cruises-sydney",
  ],
 },
 {
  title: "Milestone Birthdays",
  slugs: [
   "18th-birthday-cruises-sydney", "21st-birthday-cruises-sydney",
   "30th-birthday-cruises-sydney", "40th-birthday-cruises-sydney",
   "50th-birthday-cruises-sydney", "60th-birthday-cruises-sydney",
   "70th-birthday-cruises-sydney", "80th-birthday-cruises-sydney",
   "surprise-birthday-party-cruises-sydney", "birthday-party-boat-hire-sydney",
  ],
 },
 {
  title: "Parties",
  slugs: [
   "hens-party-cruises-sydney-harbour", "bucks-party-cruises-sydney",
   "boat-party-sydney-harbour", "harbour-party-boat-hire-sydney",
   "cocktail-party-cruises-sydney", "sunset-cruises-sydney-harbour",
   "romantic-dinner-cruises-sydney", "harbour-dining-cruises-sydney",
   "dance-floor-cruises-sydney", "live-band-cruises-sydney",
   "karaoke-cruises-sydney", "silent-disco-cruises-sydney",
   "private-function-cruises-sydney", "private-event-cruises-sydney",
   "masquerade-party-cruises-sydney", "casino-night-cruises-sydney",
  ],
 },
 {
  title: "Themed Nights",
  slugs: [
   "80s-themed-cruises-sydney", "great-gatsby-cruises-sydney",
   "tropical-theme-cruises-sydney", "white-party-cruises-sydney",
   "black-tie-cruises-sydney", "halloween-cruises-sydney-harbour",
  ],
 },
 {
  title: "Corporate & Events",
  slugs: [
   "corporate-cruises-sydney-harbour", "christmas-party-cruises-sydney",
   "eofy-cruises-sydney", "team-building-cruises-sydney",
   "product-launch-cruises-sydney", "networking-event-cruises-sydney",
   "harbour-function-venue-sydney", "sydney-harbour-event-cruises",
   "client-entertainment-cruises-sydney", "staff-appreciation-cruises-sydney",
   "business-anniversary-cruises-sydney", "corporate-hospitality-cruises-sydney",
   "gala-dinner-cruises-sydney", "awards-night-cruises-sydney",
   "vip-harbour-cruises-sydney", "business-events-sydney-harbour",
  ],
 },
 {
  title: "Networking",
  slugs: [
   "startup-networking-cruises-sydney", "executive-networking-cruises-sydney",
   "corporate-networking-cruises-sydney", "professional-networking-cruises-sydney",
   "entrepreneur-networking-events-sydney", "leadership-event-cruises-sydney",
   "women-in-business-cruises-sydney", "womens-networking-events-sydney-harbour",
   "business-networking-cruises-sydney",
  ],
 },
 {
  title: "Corporate Plus",
  slugs: [
   "conference-cruises-sydney", "agm-cruises-sydney", "board-retreat-cruises-sydney",
   "sales-kickoff-cruises-sydney", "investor-event-cruises-sydney",
   "vendor-appreciation-cruises-sydney", "staff-farewell-cruises-sydney",
   "promotion-celebration-cruises-sydney", "workshop-cruises-sydney",
   "partner-event-cruises-sydney", "breakfast-cruises-sydney",
   "summit-cruises-sydney",
  ],
 },
 {
  title: "Industry",
  slugs: [
   "real-estate-event-cruises-sydney", "legal-firm-event-cruises-sydney",
   "accounting-firm-event-cruises-sydney", "tech-company-event-cruises-sydney",
   "finance-industry-cruises-sydney", "medical-conference-cruises-sydney",
   "healthcare-event-cruises-sydney", "property-launch-cruises-sydney",
   "construction-industry-cruises-sydney", "recruitment-event-cruises-sydney",
  ],
 },
 {
  title: "Schools & Education",
  slugs: [
   "year-12-formal-cruises-sydney", "year-10-formal-cruises-sydney",
   "school-graduation-cruises-sydney", "university-graduation-cruises-sydney",
   "school-end-of-year-cruises-sydney", "pre-formal-cruises-sydney",
   "after-formal-cruises-sydney", "p-and-c-fundraiser-cruises-sydney",
   "university-event-cruises-sydney", "school-reunion-cruises-sydney",
  ],
 },
 {
  title: "Community & Charity",
  slugs: [
   "charity-cruises-sydney", "fundraising-cruises-sydney",
   "community-event-cruises-sydney", "sporting-club-cruises-sydney",
  ],
 },
 {
  title: "Cultural & Seasonal",
  slugs: [
   "nye-cruises-sydney-harbour", "nye-day-cruises-sydney",
   "vivid-cruises-sydney", "australia-day-cruises-sydney-harbour",
   "boxing-day-cruises-sydney", "valentines-day-cruises-sydney",
   "melbourne-cup-cruises-sydney", "mothers-day-cruises-sydney",
   "fathers-day-cruises-sydney", "chinese-new-year-cruises-sydney",
   "lunar-new-year-cruises-sydney", "diwali-cruises-sydney",
   "mardi-gras-cruises-sydney", "pride-cruises-sydney-harbour",
  ],
 },
 {
  title: "Boat Hire & Charter",
  slugs: [
   "private-boat-hire-sydney-harbour", "private-harbour-cruises-sydney",
   "catamaran-hire-sydney-harbour", "boat-hire-for-events-sydney",
   "byo-cruise-sydney-harbour", "super-yacht-charter-sydney-harbour",
   "charter-boat-sydney", "function-boat-hire-sydney",
   "party-boat-hire-sydney-harbour", "weekend-boat-hire-sydney",
   "luxury-boat-charter-sydney", "exclusive-boat-hire-sydney",
   "vip-boat-charter-sydney", "harbour-cruise-hire-sydney",
   "event-cruise-charter-sydney",
  ],
 },
 {
  title: "Cruise Timing",
  slugs: [
   "morning-cruises-sydney-harbour", "afternoon-cruises-sydney-harbour",
   "evening-cruises-sydney-harbour",
  ],
 },
 {
  title: "Romance & Couples",
  slugs: [
   "date-night-cruises-sydney", "couples-cruises-sydney-harbour",
   "honeymoon-cruises-sydney", "vow-renewal-cruises-sydney",
   "proposal-dinner-cruises-sydney",
  ],
 },
 {
  title: "Production & Photography",
  slugs: [
   "film-production-boat-hire-sydney", "music-video-boat-hire-sydney",
   "photography-charter-sydney",
  ],
 },
];

function labelFor(slug) {
 const legacy = SEO_PAGES.find((p) => p.slug === slug);
 if (legacy) return legacy.h1;
 const ev = SEO_EVENT_LANDINGS[slug];
 if (ev) return ev.hero?.eyebrow || ev.h1.replace(/\.$/, "");
 return null;
}

export default function SEOLinksFooter() {
 return (
  <section className="relative bg-[hsl(225,82%,9%)] border-t border-white/5 overflow-hidden" data-testid="seo-links-footer">
   {/* ambient orbs */}
   <div className="pointer-events-none absolute -top-32 left-1/4 w-[36rem] h-[36rem] rounded-full bg-amber-400/8 blur-3xl" />
   <div className="pointer-events-none absolute -bottom-32 right-1/4 w-[36rem] h-[36rem] rounded-full bg-sky-500/10 blur-3xl" />

   <div className="relative mx-auto max-w-7xl px-5 lg:px-10 py-20 lg:py-24">
    {/* Header */}
    <div className="max-w-3xl">
     <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.32em] text-amber-300 font-bold">
      <Anchor className="w-3.5 h-3.5" /> Browse all cruise types
     </div>
     <h2 className="text-white text-3xl sm:text-4xl md:text-5xl font-black tracking-tight leading-[1.05] mt-4">
      Every Sydney Harbour cruise we run.{" "}
      <span className="italic font-light text-amber-300">One scroll.</span>
     </h2>
     <p className="text-white/65 mt-4 text-base md:text-lg leading-relaxed">
      From New Year&apos;s Eve fireworks to weekday wedding ceremonies, EOFY corporate
      events to private boat hire, every Magic Cruises landing page is right here.
      Pick the cruise that fits your event and we&apos;ll do the rest.
     </p>
    </div>

    {/* Category grid */}
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-8 gap-y-10 mt-14">
     {CATEGORIES.map((cat) => (
      <div key={cat.title} data-testid={`seo-cat-${cat.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
       <div className="text-amber-300 text-[11px] uppercase tracking-[0.28em] font-bold mb-5 pb-3 border-b border-white/10">
        {cat.title}
       </div>
       <ul className="space-y-2.5">
        {cat.slugs.map((slug) => {
         const label = labelFor(slug);
         if (!label) return null;
         return (
          <li key={slug}>
           <Link
            to={`/cruises/${slug}`}
            className="group inline-flex items-start gap-2 text-sm text-white/75 hover:text-amber-300 transition-colors leading-snug"
            data-testid={`seo-link-${slug}`}
           >
            <span className="text-amber-400/60 group-hover:text-amber-300 mt-0.5">›</span>
            <span>{label}</span>
           </Link>
          </li>
         );
        })}
       </ul>
      </div>
     ))}
    </div>
   </div>
  </section>
 );
}
